import React from "react";
import { ContainerForm } from "./style";

export const Form = ({ children }) => {
  return <ContainerForm>{children}</ContainerForm>;
};
